import * as R from 'ramda'

import hasAtLeastOne from './hasAtLeastOne'

export default R.curry((prop, collection) => R.pipe(R.prop(prop), hasAtLeastOne)(collection))
